import s from "./Pricing.module.css"
import React from "react";
import {Link} from "react-router-dom";
import {PRICING_NOTICE} from "../../../Constants/RoutesConstants";

export const PricingBusinessAccountMobile = () => {
    return (
        <div className={s.wrapper}>
            <div className={s.container}>
                <div className={s.title}>
                    Pricing
                </div>
                <div className={s.title_mobile}>Business Account</div>
                <div className={s.table_wrap}>
                    <div className={s.table_header}>
                        <span>Small Business / Standard Risk</span>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Account opening and maintenance
                        </div>
                        <div className={s.values_block}>
                            <div className={s.row}>
                                         <span>
                                        Account opening fee (paid after the account opening confirmation) <br/>
                                        *The final fee is determined by the compliance team after application evaluation
                                        </span>
                                <span>From € 150 to € 250 *</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Account maintenance fee, monthly
                                    </span>
                                <span>€ 25</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                    Remaining balance fee for outstanding funds, when business relationship terminated
                                </span>
                                <span>5 % per month from the balance on the account, but not less than 50 euro</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Priority review of the application
                                    </span>
                                <span>€ 1500 – € 2000</span>
                            </div>

                            <div className={s.row}>
                                   <span>
                                   Inactive (after 3 month of inactivity) account maintenance fee, monthly
                                </span>
                                <span>€ 75</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                    Closing account fee
                                    <br/>
                                    *not charged in case it is a client decision to close the account
                                    and the account was opened longer than 6 months
                                </span>
                                <span>€ 100</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Internal payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            Internal transfer
                                        </span>
                                <span>€ 3</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Outgoing payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            SEPA / SEPA instant
                                        </span>
                                <span>0.15 % Min 3 EUR</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                            SWIFT / Target2 (EUR only) outgoing
                                        </span>
                                <span>0.4 %, Min € 35 + correspondent banking fees may apply</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Incoming payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            SEPA / SEPA instant
                                        </span>
                                <span>0.1 % Min 3 EUR</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                            SWIFT / Target2 (EUR only) incoming
                                        </span>
                                <span>0.35 %, Min € 35 + correspondent banking fees may apply</span>
                            </div>

                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Other fees
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            Payment data / Amendment / Investigation, etc.
                                        </span>
                                <span>€ 150</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                            SWIFT / Target2 payment cancellation
                                        </span>
                                <span>€ 150</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                            SEPA / SEPA instant cancellation
                                        </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        Fee for signed account statement
                                        </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                       <span>
                                        Additional account opening fee for complex structure of legal entities
                                        </span>
                                <span>Min € 500 – Max € 1 000</span>
                            </div>

                            <div className={s.row}>
                                         <span>
                                        Currency exchange
                                    </span>
                                <span>1,50%</span>
                            </div>

                            <div className={s.row}>
                                       <span>
                                        Penalty for Client avoiding to collaborate or failing to provide documentation within the deadline indicated by LuxPay* <br/>
                                        * In case client is not collaborating after notifications from LuxPay
                                        </span>
                                <span>3% from the turnover of last three months on the account, but not less than 100 euro</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Account confirmation letter
                                    </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Updating information related to significant structural changes of a legal-entity client in the LuxPay system
                                    </span>
                                <span>€ 50</span>
                            </div>
                        </div>

                    </div>

                    <div className={s.table_header}>
                        <span>Medium Business / Elevated Risk</span>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Account opening and maintenance
                        </div>
                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                        Account opening fee (paid after the account opening confirmation) <br/>
                                        *The final fee is determined by the compliance team after application evaluation
                                    </span>
                                <span>From € 200 to € 350 *</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Account maintenance fee, monthly
                                    </span>
                                <span>€ 50 </span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                    Remaining balance fee for outstanding funds, when business relationship terminated
                                </span>
                                <span>5 % per month from the balance on the account, but not less than 50 euro</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Priority review of the application
                                    </span>
                                <span>€ 1500 – € 2000</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                   Inactive (after 3 month of inactivity) account maintenance fee, monthly
                                </span>
                                <span>€ 75</span>
                            </div>

                            <div className={s.row}>
                                   <span>
                                    Closing account fee
                                    <br/>
                                    *not charged in case it is a client decision to close the account
                                    and the account was opened longer than 6 months
                                    </span>
                                <span>€ 150</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Internal payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                         <span>
                                        Internal transfer
                                    </span>
                                <span>€ 4</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Outgoing payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                         <span>
                                        SEPA / SEPA instant
                                    </span>
                                <span>0.2 % Min 4 EUR</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                       SWIFT / Target2 (EUR only) outgoing
                                    </span>
                                <span>0.45 %, Min € 40 + correspondent banking fees may apply</span>
                            </div>

                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Incoming payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                       <span>
                                       SEPA / SEPA instant
                                    </span>
                                <span>0.15 % Min 4 EUR</span>
                            </div>

                            <div className={s.row}>
                                       <span>
                                       SWIFT / Target2 (EUR only) incoming
                                    </span>
                                <span>0.4 %, Min € 40 + correspondent banking fees may apply</span>
                            </div>

                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Other fees
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                        Payment data / Amendment / Investigation, etc.
                                    </span>
                                <span>€ 150</span>
                            </div>

                            <div className={s.row}>
                                         <span>
                                        SWIFT / Target2 payment cancellation
                                    </span>
                                <span>€ 150</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        SEPA / SEPA instant cancellation
                                    </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                       Fee for signed account statement
                                    </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        Additional account opening fee for complex structure of legal entities
                                    </span>
                                <span>Min € 500 – Max € 1 000</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        Currency exchange
                                    </span>
                                <span>1,50%</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        Penalty for Client avoiding to collaborate or failing to provide documentation within the deadline indicated by LuxPay* <br/>
                                        * In case client is not collaborating after notifications from LuxPay
                                    </span>
                                <span>3% from the turnover of last three months on the account, but not less than 100 euro</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        Account confirmation letter
                                    </span>
                                <span>€ 50</span>
                            </div>
                            <div className={s.row}>
                                    <span>
                                        Updating information related to significant structural changes of a legal-entity client in the LuxPay system
                                    </span>
                                <span>€ 50</span>
                            </div>
                            <div className={s.table_body_subtitle}>
                                * Final fee will be provided after first view within 24 hours
                            </div>

                            <div className={s.table_body_subtitle}>
                                ** Please see which fee type your business falls under here: <Link to={PRICING_NOTICE}>Pricing
                                Notice</Link>
                            </div>
                        </div>

                    </div>

                    <div className={s.table_header}>
                        <span>Medium-High Business / High Operational Complexity</span>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Account opening and maintenance
                        </div>
                        <div className={s.values_block}>
                            <div className={s.row}>
                                         <span>
                                        Account opening fee (paid after the account opening confirmation) <br/>
                                        *The final fee is determined by the compliance team after application evaluation
                                    </span>
                                <span>From € 350 to € 500 *</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                        Account maintenance fee, monthly
                                    </span>
                                <span>€ 100</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                    Remaining balance fee for outstanding funds, when business relationship terminated
                                </span>
                                <span>5 % per month from the balance on the account, but not less than 50 euro</span>
                            </div>

                            <div className={s.row}>
                                   <span>
                                    Priority review of the application
                                </span>
                                <span>€ 1500 – € 2000</span>
                            </div>

                            <div className={s.row}>
                                     <span>
                                   Inactive (after 3 month of inactivity) account maintenance fee, monthly
                                </span>
                                <span>€ 100</span>
                            </div>

                            <div className={s.row}>
                                    <span>
                                    Closing account fee
                                    <br/>
                                    *not charged in case it is a client decision to close the account
                                    and the account was opened longer than 6 months
                                </span>
                                <span>€ 200</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Internal payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            Internal transfer
                                        </span>
                                <span>€ 6</span>
                            </div>
                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Outgoing payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            SEPA / SEPA instant
                                        </span>
                                <span>0.2 % Min 6 EUR</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        SWIFT / Target2 (EUR only) outgoing
                                        </span>
                                <span>0.45 %, Min € 50 + correspondent banking fees may apply</span>
                            </div>


                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Incoming payments
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                        SEPA / SEPA instant
                                        </span>
                                <span>0.2 % Min 6 EUR</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        SWIFT / Target2 (EUR only) incoming
                                        </span>
                                <span>0.45 %, Min € 50 + correspondent banking fees may apply</span>
                            </div>

                        </div>
                    </div>
                    <div className={s.table_body}>
                        <div className={s.table_body_subtitle}>
                            Other fees
                        </div>

                        <div className={s.values_block}>
                            <div className={s.row}>
                                        <span>
                                            Payment data / Amendment / Investigation, etc.
                                        </span>
                                <span>€ 150</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                            SWIFT / Target2 payment cancellation
                                        </span>
                                <span>€ 150</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                            SEPA / SEPA instant cancellation
                                        </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                        Fee for signed account statement
                                        </span>
                                <span>€ 50</span>
                            </div>

                            <div className={s.row}>
                                        <span>
                                           Currency exchange
                                        </span>
                                <span>1,50%</span>
                            </div>

                            <div className={s.row}>
                                         <span>
                                        Penalty for Client avoiding to collaborate or failing to provide documentation within the deadline indicated by LuxPay* <br/>
                                        * In case client is not collaborating after notifications from LuxPay
                                    </span>
                                <span>3% from the turnover of last three months on the account, but not less than 100 euro</span>
                            </div>
                            <div className={s.row}>
                                    <span>
                                        Account confirmation letter
                                    </span>
                                <span>€ 50</span>
                            </div>
                            <div className={s.row}>
                                    <span>
                                        Updating information related to significant structural changes of a legal-entity client in the LuxPay system
                                    </span>
                                <span>€ 50</span>
                            </div>
                        </div>
                        <div className={s.table_body_subtitle}>
                            * Final fee will be provided after first view within 24 hours
                        </div>

                        <div className={s.table_body_subtitle}>
                            ** Please see which fee type your business falls under here: <Link to={PRICING_NOTICE}>Pricing
                            Notice</Link>
                        </div>

                    </div>

                </div>

                <div className={s.table_header}>
                    <span>High-Risk Sector</span>
                </div>
                <div className={s.table_body}>
                    <div className={s.table_body_subtitle}>
                        Account opening and maintenance
                    </div>
                    <div className={s.values_block}>
                        <div className={s.row}>
                                         <span>
                                        Account opening fee (paid after the account opening confirmation)<br/>
                                        *The final fee is determined by the compliance team after application evaluation <br/>
                                        * For high-risk clients, 50% of the account opening fee is charged in advance and it is non-refundable if unsuccessful
                                    </span>
                            <span>From € 1000 to € 1500 *</span>
                        </div>

                        <div className={s.row}>
                                    <span>
                                        Account maintenance fee, monthly
                                    </span>
                            <span>€ 150</span>
                        </div>

                        <div className={s.row}>
                                     <span>
                                    Remaining balance fee for outstanding funds, when business relationship terminated
                                </span>
                            <span>5 % per month from the balance on the account, but not less than 50 euro</span>
                        </div>

                        <div className={s.row}>
                                   <span>
                                    Priority review of the application
                                </span>
                            <span>€ 1500 – € 2000</span>
                        </div>

                        <div className={s.row}>
                                     <span>
                                   Inactive (after 3 month of inactivity) account maintenance fee, monthly
                                </span>
                            <span>€ 150</span>
                        </div>

                        <div className={s.row}>
                                     <span>
                                    Closing account fee
                                    <br/>
                                    *not charged in case it is a client decision to close the account
                                    and the account was opened longer than 6 months
                                </span>
                            <span>€ 250</span>
                        </div>
                    </div>
                </div>
                <div className={s.table_body}>
                    <div className={s.table_body_subtitle}>
                        Internal payments
                    </div>

                    <div className={s.values_block}>
                        <div className={s.row}>
                                        <span>
                                        Internal transfer
                                    </span>
                            <span>€ 8</span>
                        </div>
                    </div>
                </div>
                <div className={s.table_body}>
                    <div className={s.table_body_subtitle}>
                        Outgoing payments
                    </div>

                    <div className={s.values_block}>
                        <div className={s.row}>
                                       <span>
                                        SEPA / SEPA instant
                                    </span>
                            <span>0.3 % Min 8 EUR</span>
                        </div>

                        <div className={s.row}>
                                        <span>
                                       SWIFT / Target2 (EUR only) outgoing
                                    </span>
                            <span>0.55 %, Min € 50 + correspondent banking fees may apply</span>
                        </div>


                    </div>
                </div>
                <div className={s.table_body}>
                    <div className={s.table_body_subtitle}>
                        Incoming payments
                    </div>

                    <div className={s.values_block}>
                        <div className={s.row}>
                                         <span>
                                       SEPA / SEPA instant
                                    </span>
                            <span>0.25 % Min 8 EUR</span>
                        </div>

                        <div className={s.row}>
                                         <span>
                                       SWIFT / Target2 (EUR only) incoming
                                    </span>
                            <span>0.5 %, Min € 50 + correspondent banking fees may apply</span>
                        </div>

                    </div>
                </div>
                <div className={s.table_body}>
                    <div className={s.table_body_subtitle}>
                        Other fees
                    </div>

                    <div className={s.values_block}>
                        <div className={s.row}>
                                       <span>
                                        Payment data / Amendment / Investigation, etc.
                                    </span>
                            <span>€ 150</span>
                        </div>

                        <div className={s.row}>
                                        <span>
                                        SWIFT / Target2 payment cancellation
                                    </span>
                            <span>€ 150</span>
                        </div>

                        <div className={s.row}>
                                         <span>
                                        SEPA / SEPA instant cancellation
                                    </span>
                            <span>€ 50</span>
                        </div>

                        <div className={s.row}>
                                         <span>
                                       Fee for signed account statement
                                    </span>
                            <span>€ 50</span>
                        </div>

                        <div className={s.row}>
                                       <span>
                                        Additional account opening fee for complex structure of legal entities
                                    </span>
                            <span>Min € 500 – Max € 1 000</span>
                        </div>

                        <div className={s.row}>
                                         <span>
                                        Currency exchange
                                    </span>
                            <span>1,50%</span>
                        </div>
                        <div className={s.row}>
                                   <span>
                                        Penalty for Client avoiding to collaborate or failing to provide documentation within the deadline indicated by LuxPay* <br/>
                                        * In case client is not collaborating after notifications from LuxPay
                                    </span>
                            <span>3% from the turnover of last three months on the account, but not less than 100 euro</span>
                        </div>
                        <div className={s.row}>
                                     <span>
                                        Account confirmation letter
                                    </span>
                            <span>€ 50</span>
                        </div>
                        <div className={s.row}>
                                    <span>
                                        Updating information related to significant structural changes of a legal-entity client in the LuxPay system
                                    </span>
                            <span>€ 50</span>
                        </div>
                    </div>
                    <div className={s.table_body_subtitle}>
                        * Final fee will be provided after first view within 24 hours
                    </div>

                    <div className={s.table_body_subtitle}>
                        ** Please see which fee type your business falls under here: <Link to={PRICING_NOTICE}>Pricing
                        Notice</Link>
                    </div>
                </div>

            </div>

        </div>
    )
}
